import { Component, inject } from '@angular/core';
import { ScreenTrackingService } from '@angular/fire/analytics';
import { RouterOutlet } from '@angular/router';

import { firebaseAnalyticsEnabled } from './core/firebase/firebase.providers';
import { SiteFooterComponent } from './core/layout/site-footer.component';
import { SiteHeaderComponent } from './core/layout/site-header.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, SiteHeaderComponent, SiteFooterComponent],
  templateUrl: './app.html',
  styleUrl: './app.css'
})
export class App {
  private readonly screenTrackingService = firebaseAnalyticsEnabled
    ? inject(ScreenTrackingService)
    : null;
}
